import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["viewCardCard", "viewTitle", "viewCardCardBody", "previewCard", "editCardBtn", "deleteCardBtn", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--cards--entities--show`
    // this.doViewHtml()
  }

  doViewHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="viewCardCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 py-3" style="font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Nenhum Cartão de Crédito Selecionado</h6>
                  </div>
                  <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="viewCardCardBody"></div>
                </div>`

    this.getControllerByIdentifier("financials--books--cards--entities--dashboard").contentTarget.innerHTML = html
  }


  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
